import React from "react";
import './UpDownIndicator.css';

class UpDownIndicator extends React.Component
{

    onDown = () =>
    {
        console.log("Down");
    }

    onUp = () =>
    {
        console.log("Up");
    }

    render() {
        const cssClass = `up-down-indicator-text-${this.props.siteStatus.toLowerCase()}`;
        return(
            <div className="up-down-indicator-text" ><span className="up-down-indicator-text">Site Status: </span><span className={cssClass}>{this.props.siteStatus}</span></div>
        );
    }
}

export default UpDownIndicator;
